import axios from 'axios';
import Vue from 'vue';
import { errorHandler } from "../exports/error_management";

import { buildQuery } from '../exports/queryStringBuilder'
const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)

const state = {
    assetSchedules: [],
    assetSchedulesNotPaginated: [],
    asset_schedules_all: [],
    itemsChanged: false,
    pagination: null,
    assets_pagination:null,
    filters: {},
}

const getters = {

    getAssetSchedules: (state) => state.assetSchedules,
    getAssetScheduleById: (state) => (id) => state.assetSchedules.find(schedule => schedule.id === id)
}

const mutations = {
    SET_SCHEDULE(state, schedules) {
        state.schedules = schedules
    },
    SET_CHANGED(state, x) {
        state.itemsChanged = x
    },
    clearAssetSchedules(state) {
        state.assetSchedules = []; 
    },

    SET_ASSET_SCHEDULES(state, schedules) {
        state.assetSchedules = schedules;
    },
    SET_FILTERS(state, payload) {
        state.filters = payload;
    },
    SET_ASSET_SCHEDULES_NOT_PAGINATED(state, schedules) {
        state.assetSchedulesNotPaginated = schedules;
    },
    ADD_ASSET_SCHEDULE(state, schedule) {
        state.assetSchedules.push(schedule);
    },
    UPDATE_ASSET_SCHEDULE(state, updatedSchedule) {
        const index = state.assetSchedules.findIndex(schedule => schedule.id === updatedSchedule.id);
        if (index !== -1) {
            Vue.set(state.assetSchedules, index, updatedSchedule);
        }
    },
    DELETE_ASSET_SCHEDULE(state, scheduleId) {
        state.assetSchedules = state.assetSchedules.filter(schedule => schedule.id !== scheduleId);
    },
    SET_PAGINATION(state, pag) {
        state.pagination = pag;
      },
    SET_ASSET_SCHEDULE_PAGINATION(state, pag) {
        state.assets_pagination = pag
    },

    SET_ASSET_SCHEDULE_DATA(state, payload) {
        state.asset_schedules_all = payload
    },
}

const actions = {
    load({ commit }, initialItems) {
        const schedules =
            initialItems &&
            initialItems.map(x => {
                x.hash = x.hash || getHash()
                return x
            })
        commit('SET_SCHEDULE', schedules)
        commit('SET_CHANGED', false)
    },

    clear({ commit }) {
        commit('SET_SCHEDULE', [])
        commit('SET_CHANGED', false)
    },
    
    merge({ state, commit }, item) {

        if(item)
        item.hash = item.hash || getHash()
        const schedules = state.schedules ? [...state.schedules] : []
        let index = schedules.findIndex(x => x.hash == item.hash)
        if (index >= 0) schedules.splice(index, 1, item)
        else schedules.push(item)
        console.log('schedules after', schedules)
        commit('SET_CHANGED', true)
        commit('SET_SCHEDULE', schedules)
    },

    delete({ state, commit }, hash) {
        const schedules = [...state.schedules]
        const index = schedules.findIndex(x => x.hash == hash)
        schedules.splice(index, 1)
        commit('SET_CHANGED', true)
        commit('SET_SCHEDULE', schedules)
    },
  
    async fetchAssetSchedules({ commit },params) {
        let { assetId, page: pg,type_id,filters  } = params || {}
      
        pg = pg || 0
        assetId = assetId || ""
        type_id = type_id || ""
        
        let crm = false

            // Start building the URL with the mandatory parameters
        let url = `asset/schedules?page=${pg}&asset_id=${assetId}&is_crm=${crm}&type_id=${type_id}`;
        
        // Add optional parameters if they are set in filters
        if (filters?.customer_id) {
            url += `&customer_id=${filters.customer_id}`;
        }
        if (filters?.default_engineer_id) {
            url += `&default_engineer_id=${filters.default_engineer_id}`;
        }
        if (filters?.role_id) {
            url += `&role_id=${filters.role_id}`;
        }
        if (filters?.last_service_from) {
            url += `&last_service_from=${filters.last_service_from}`;
        }
        if (filters?.last_service_to) {
            url += `&last_service_to=${filters.last_service_to}`;
        }
        if (filters?.next_service_from) {
            url += `&next_service_from=${filters.next_service_from}`;
        }
        if (filters?.next_service_to) {
            url += `&next_service_to=${filters.next_service_to}`;
        }
        if (filters?.warranty_from) {
            url += `&warranty_from=${filters.warranty_from}`;
        }
        if (filters?.warranty_to) {
            url += `&warranty_to=${filters.warranty_to}`;
        }
        
        // Make the API call with the built URL
        const response = await axios.get(url);
    
        // const response = await axios.get(`asset/schedules?page=${pg}&asset_id=${assetId}&is_crm=${crm}&type_id=${type_id}`);
        
        let value = response.data.success.data;
        if(pg > 0) {
            const {
                data: _schedule = [],
                current_page: page,
                per_page: pageSize = 15,
                total = 0,
            } = value || {};

            
            console.log('page size------',pageSize);
            console.log('total------',total);
            console.log('_schedule--------',_schedule);
            commit("SET_PAGINATION", {
                page,
                pageSize,
                total,
            });
            commit('SET_ASSET_SCHEDULES',_schedule);
        } else {
            commit('SET_ASSET_SCHEDULES_NOT_PAGINATED',[]);
            commit('SET_ASSET_SCHEDULES_NOT_PAGINATED',value);
        }
    },
    async fetch_all_schedules({commit}, params) {
        try {
            let { query, page: pg, filters,crm } = params || {}
            query = query || ''
            pg = pg || 0
            filters = filters || {}
            crm = crm || false

            console.log('filter---',buildQuery(filters));
            const path = `asset/schedules?q=${query}&page=${pg}&${buildQuery(filters)}&is_crm=${crm}`
            console.log('--path--', path)
            const results = await axios.get(path)
            console.log('fetch results', results)
            if(pg > 0){
                let {
                    data,
                    current_page: page,
                    per_page: pageSize,
                    total,
                } = results.data.success.data
                console.log('page0------', page)
                console.log('pagesize------', page)
                console.log('total------', total)
                const pag = {
                    page,
                    pageSize,
                    total,
                }
                //const assets = data.data.success.data
                commit('SET_ASSET_SCHEDULE_DATA', data)
                commit('SET_ASSET_SCHEDULE_PAGINATION', pag)
                commit('SET_FILTERS', filters);
            } else {
                let value = results.data.success.data;
                commit('SET_ASSET_SCHEDULES_NOT_PAGINATED',[]);
                commit('SET_ASSET_SCHEDULES_NOT_PAGINATED',value);
            }
        } catch (err) {
            console.error('asset fetch:', err)
            errorHandler(err)
        }
    },
    async addAssetSchedule({ commit },{ schedule, assetId }) {
        
        const response = await axios.post(`asset/${assetId}/schedules`, schedule);
        commit('ADD_ASSET_SCHEDULE', response.data.success.data);
    },
    async updateAssetSchedule({ commit }, { schedule, assetId }) {
        
        const response = await axios.put(`asset/${assetId}/schedules/${schedule.id}`, schedule);
        commit('UPDATE_ASSET_SCHEDULE', response.data.success.data);
    },
    async deleteAssetSchedule({ commit }, { schedule, assetId }) {
       
        await axios.delete(`asset/${assetId}/schedules/${schedule}`);
        commit('DELETE_ASSET_SCHEDULE', schedule);
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
